import { ProductionStatus } from "@enums/productionStatus.enum";

export function GetProductionStatusColorOpsPlannerButton(status: ProductionStatus) {
	switch (status) {
		case ProductionStatus.Active:
		case ProductionStatus.Changeover:
			return "#DCFCE7";
		case ProductionStatus.ToiletBreak:
		case ProductionStatus.Break:
		case ProductionStatus.QLoop:
		case ProductionStatus.QualityCheck:
		case ProductionStatus.AssistanceRequired:
			return "#FDEDD5";
		case ProductionStatus.Idle:
		case ProductionStatus.Inactive:
		case ProductionStatus.InitialCheckFailed:
		case ProductionStatus.Breakdown:
		case ProductionStatus.Maintenance:
			return "#FCE3E3";
		default:
			return "blue";
	}
}